<template>
  <a class="scrolltop" @click="scrollTop"><img class="" alt="" src="/static/img/pictos/flecheblanche.svg"></a>
</template>

<script>
export default {
  name: "Scrolltop",
  methods: {
    // Renvoie en haut de l'écran : utile sur la version mobile
    scrollTop() {
      window.scrollTo(0, 0);
    }
  }
};
</script>

<style lang="scss" scoped>
  @import "~@/assets/scss/_colors.scss";

  .scrolltop{ background-color: $color1; width: 20px; height: 20px; display: block; position: fixed; bottom: 161px; left: 0; z-index: 10; display: flex; align-items: center; justify-content: center; transform: rotate(-90deg);
    img{ width: 8px; }
  }
</style>



// WEBPACK FOOTER //
// src/components/Global/Scrolltop.vue